import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Styles.css'; // Reusing Styles.css for consistency
import './Login.css';
import Util from './Util';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';

const Login = ({ onLogin, onSignup }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [loading, setLoading] = useState(false); // State to manage spinner visibility
  const navigate = useNavigate();
  const {executeRecaptcha} = useGoogleReCaptcha();


  // Function to call the server-side API
  const loginFunc = async () => {
    let emailStr = email.trim().toLowerCase();  
    

    setError(''); // Clear any existing error messages 
    setSuccess('');

    setLoading(true); // Show the spinner while processing


    if(!executeRecaptcha) alert("Recaptcha not ready");
    const recaptchaToken = await executeRecaptcha("login");

    const command = Util.serverName + "/api/doLogin"; // Base API endpoint

    try {
      // Make the API call using POST method with a JSON body
      const response = await fetch(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({ email: emailStr, password, captcha:recaptchaToken}), // JSON payload
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');

        setError(data.message);
        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        setError(data.message);
        return;
        // throw new Error(data.msg);
      }

      // Navigate to the email verification page if everything is successful
      // navigate('/email-verification');
      let obj = data.user;
      let globals = data.globals;
      // console.log(JSON.stringify(obj));

      onLogin(obj, globals);
      /*
      if(obj==undefined || obj.inactive == undefined)
      {
        navigate('/email-verification');
        onSignup(1);
      }


      if(obj.inactive ==true)
      {
        navigate('/email-verification');
      }
      else
      {

        if(obj.subscribed == false)
        {
          navigate("/subscription-setup");      
        }
        else
        {
          navigate('/dashboard');
        }
      }
      */
      
    } catch (error) {
      // Set the error message to be displayed to the user
      console.log(error.message);
      setError(error.message);
    } finally {
      // Always remove the loading state, whether the request succeeded or failed
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let ut = Util.getInstance();
    // Validate input fields
    if (!email || !password) {
      setError('Both email and password are required.');
      return;
    }

    let rt=ut.validateEmail(email);
    if(!rt.valid)
    {
      setError(rt.message);
      return;
    }

    if(!ut.isStrongPassword(password))
    {
      let msg = 'A bad password type entered';
      setError(msg);
      return;
    }

    // Logic for handling login (e.g., sending data to a backend)
    console.log('User logged in with:', { email, password });

    await loginFunc();
    // onLogin();
    console.log('Login should have been called');
    // navigate('/dashboard');
  };

  const handleResetPasswordClick = async () => {
    try
    {
        let emailStr = email.trim().toLowerCase();  

        let ut = Util.getInstance();

        let rt=ut.validateEmail(emailStr);
        if(!rt.valid)
        {
          setError(rt.message);
          return;
        }
    
        console.log("Email: ",emailStr);
        const command = Util.serverName + "/api/resetPassword"; // Base API endpoint
        const response = await fetch(command, 
            {
              method: 'POST', // Use POST method
              headers: { 'Content-Type': 'application/json' }, // Specify JSON format
              body: JSON.stringify({ email: emailStr })
            });

        console.log("Reset password");
        const data = await response.json(); // Parse the JSON response
        if(!response.ok)
        {
            console.log("Bad response from fetch");
            setError(data.message);
            return;
        }
        
        if(data)
        {
          setSuccess(data.message);
        }
        else
        {
          let msg = ('Unable to reset password');
          setError(msg);
        }                
    }
    catch (err)
    {        
        setError(err.message);
    } 

  };

  const handleBackClick = () => {
    navigate('/'); // Navigate back to the Coming Soon page
  };

  const eye = '\u{1F441}';  // Eye symbol using Unicode escape
  const crossedOutEye = '\u{1F648}';// '\u{1F6AB}\u{1F441}';  // Crossed-out eye symbol
  return (
    <div className="app-container">
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="container">
        <div className="title">Login</div>
        <div className="subtitle">Access your account to continue.</div>

        {/* Display error message if any */}
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
            />
          </div>

          <div className="form-group password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-password-btn"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {!showPassword ? crossedOutEye : eye}
            </button>
          </div>

          <button type="submit" className="button">Log In</button>
        </form>

        <div className="alternative-action">
          <p>
            <a href="#" onClick={handleResetPasswordClick} className="reset-link">
              Forgot your password? Reset it here.
            </a>
          </p>
        </div>

        {/* Back Button */}
        <button onClick={handleBackClick} className="button back-btn">Home Page</button>
      </div>
    </div>
  );
};

export default Login;

